var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmployeeinfo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "EmployInfo",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M3.33 5.98v17.91a4.993 4.993 0 0 0 4.98 4.98h6.74a7.016 7.016 0 0 1 .59-2 7.632 7.632 0 0 1 4.08-3.92 4.896 4.896 0 0 1-2.11-4.04 4.955 4.955 0 0 1 4.95-4.95 4.718 4.718 0 0 1 1.41.21 4.905 4.905 0 0 1 2 1.16V5.98A4.98 4.98 0 0 0 20.99 1H8.31a4.987 4.987 0 0 0-4.98 4.98zm6.04-.02h10.56a1 1 0 0 1 0 2H9.37a1 1 0 0 1 0-2zm0 5.32h10.56a1 1 0 0 1 0 2H9.37a1 1 0 0 1 0-2zm0 5.31h4.8a1 1 0 1 1 0 2h-4.8a1 1 0 1 1 0-2z",
    fill: "#7b818e",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.56,
    cy: 18.91,
    r: 3.45,
    fill: "#7b818e",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.46 31h10.21a1.003 1.003 0 0 0 1-1 6.105 6.105 0 0 0-12.21 0 1.003 1.003 0 0 0 1 1z",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployeeinfo);
export default __webpack_public_path__ + "static/media/Employee info.9aa71c7c996adc04c70faa1662883145.svg";
export { ForwardRef as ReactComponent };